/* eslint-disable arrow-parens */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */

import { docTextRowHandler, formatMoney, getUomByVariation, getCourierServiceLabel } from '@/lib/helper';

const drawRect = (doc, x1, x2, y1, y2) => {
	doc.line(x1, y1, x2, y1);
	doc.line(x2, y1, x2, y2);
	doc.line(x1, y2, x2, y2);
	doc.line(x1, y1, x1, y2);
};

const headerLayout = (doc, state, courierLogo, codLabel, isCourierVisible) => {
	const { minX, minY, maxX, fontSize } = state;
	const headerHeight = minY + 24;
	const headerBreakX = minX + 160;

	const logo = courierLogo?.data;
	let logoWidth = 60;
	let logoHeight = courierLogo ? (logoWidth / courierLogo.width) * courierLogo.height : 0;
	let logoPosX = minX + 10;
	let logoPosY = minY + headerHeight / 2 - logoHeight;
	const codPosX = headerBreakX + (maxX - headerBreakX) / 2;

	if (isCourierVisible && logo) {
		if (courierLogo.key === 'oexpress') {
			logoWidth = 60;
			logoHeight = courierLogo ? (logoWidth / courierLogo.width) * courierLogo.height : 0;
			logoPosX = minX + 10;
			logoPosY = minY + 7;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'sap') {
			logoWidth = 25;
			logoHeight = 18;
			logoPosX = minX + 10;
			logoPosY = minY + 3;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'ninja') {
			logoWidth = 40;
			logoHeight = 15;
			logoPosX = minX + 10;
			logoPosY = minY + 5;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'idexpress') {
			logoWidth = 25;
			logoHeight = 15;
			logoPosX = minX + 10;
			logoPosY = minY + 5;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'jne') {
			logoWidth = 25;
			logoHeight = 15;
			logoPosX = minX + 10;
			logoPosY = minY + 5;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'jne') {
			logoWidth = 25;
			logoHeight = 15;
			logoPosX = minX + 10;
			logoPosY = minY + 5;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		} else if (courierLogo.key === 'jnt') {
			logoWidth = 45;
			logoHeight = 13;
			logoPosX = minX + 10;
			logoPosY = minY + 6;
			doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
		}

		// doc.addImage(logo, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);
	}

	doc.setFontType('bold');
	doc.setFontSize(10);
	doc.text(codLabel, codPosX, minY + headerHeight / 2, { align: 'center' });
	doc.setFontSize(fontSize);
	doc.setFontType('normal');

	doc.line(minX, headerHeight, maxX, headerHeight);
	doc.line(headerBreakX, minY, headerBreakX, headerHeight);

	return headerHeight;
};

const awbLayout = (doc, state, barcodeImage, orderIdLabel, awbLabel) => {
	const { minX, maxX, currentY, width, lineWidth, fontSize } = state;
	const halfWidth = (maxX - minX) / 2;
	const offset = 7;
	const borderLength = halfWidth - 10.5;
	const borderX2 = maxX - offset;
	const borderX1 = borderX2 - borderLength;
	const borderY1 = currentY + 3;
	const borderY2 = currentY + 14;
	const orderIdPosX = minX + offset + borderLength / 2;
	const awbPosX = borderX1 + borderLength / 2;
	const textPosY = currentY + 11;
	const barcodeWidth = 170;
	const barcodeHeight = 40;
	const barcodePosX = (width - barcodeWidth) / 2;
	const barcodePosY = currentY + 8;
	const endLinePosY = currentY + barcodeHeight + 3;

	if (barcodeImage) {
		doc.addImage(barcodeImage, 'PNG', barcodePosX, barcodePosY, barcodeWidth, barcodeHeight);
	}

	doc.setLineWidth(lineWidth + 0.5);
	drawRect(doc, minX + offset, minX + offset + borderLength, borderY1, borderY2);
	drawRect(doc, borderX1, borderX2, borderY1, borderY2);

	doc.setFontType('bold');
	doc.setFontSize(7);
	doc.text(orderIdLabel, orderIdPosX, textPosY, { align: 'center' });
	doc.text(awbLabel, awbPosX, textPosY, { align: 'center' });
	doc.setFontSize(fontSize);
	doc.setFontType('normal');

	doc.setLineWidth(lineWidth);
	doc.line(minX, endLinePosY, maxX, endLinePosY);

	return endLinePosY + 10;
};

const addressLayout = (doc, state, data, insertInstructions) => {
	const { receiverName, senderName, receiverPhone, senderPhone } = data;

	let lastPosY = state.currentY;
	let leftPosY = state.currentY;
	let rightPosY = state.currentY;
	const leftPosX = state.minX + state.padding;
	const rightPosX = state.minX + state.padding / 2 + (state.maxX - state.minX) / 2;

	doc.setFontType('bold');
	doc.text('Kepada:', leftPosX, leftPosY);
	doc.text('Dari:', rightPosX, rightPosY);
	doc.setFontType('normal');

	docTextRowHandler(doc, receiverName, leftPosX, leftPosY, 28, state.lineHeight, 30, 8, 1);
	leftPosY = 104;
	rightPosY =
		docTextRowHandler(
			doc,
			senderName,
			rightPosX + 18,
			rightPosY,
			30,
			state.lineHeight,
			null,
			null,
			0,
		) + state.lineHeight;

	doc.setFontType('bold');
	doc.text('Telp:', leftPosX, leftPosY);
	if (data.isSenderPhoneVisible) doc.text('Telp:', rightPosX, rightPosY);
	doc.setFontType('normal');
	doc.text(receiverPhone, leftPosX + 19, leftPosY);
	if (data.isSenderPhoneVisible) doc.text(senderPhone, rightPosX + 19, rightPosY);

	leftPosY += state.lineHeight;
	rightPosY = leftPosY;

	if (data.notes && data.notes?.length > 0) {
		doc.setFontType('bold');
		doc.text('Catatan:', rightPosX, rightPosY);
		doc.setFontType('normal');
		rightPosY =
			docTextRowHandler(
				doc,
				data.notes,
				rightPosX,
				rightPosY,
				28,
				state.lineHeight,
				30,
				8,
				2,
			) + state.lineHeight;
	}

	leftPosY =
		docTextRowHandler(
			doc,
			data.address,
			leftPosX,
			leftPosY,
			36,
			state.lineHeight,
			null,
			null,
			2,
		) + state.lineHeight;
	leftPosY =
		docTextRowHandler(
			doc,
			data.addressDetail,
			leftPosX,
			leftPosY,
			36,
			state.lineHeight,
			null,
			null,
			1,
		) + state.lineHeight;

	lastPosY = Math.max(leftPosX, leftPosY) - state.lineHeight;

	if (data.instructions.length > 0) {
		const instructionOptions = {
			startY: lastPosY - state.padding,
			leftX: leftPosX,
			rightX: state.maxX - state.padding,
		};
		lastPosY = insertInstructions(doc, instructionOptions, data.instructions) + state.padding;
	}

	lastPosY += state.padding;

	doc.line(state.minX, lastPosY, state.maxX, lastPosY);

	lastPosY += state.padding;

	const boxHeight = 15;
	const cityBorderX1 = leftPosX;
	const cityBorderX2 = rightPosX - state.padding;
	const subdistrictBorderX1 = rightPosX;
	const subdistrictBorderX2 = state.maxX - state.padding;
	const cityTextPosX = cityBorderX1 + (cityBorderX2 - cityBorderX1) / 2;
	const subdistrictTextPosX =
		subdistrictBorderX1 + (subdistrictBorderX2 - subdistrictBorderX1) / 2;
	const textPosY = lastPosY + boxHeight / 2 + state.lineHeight / 4;

	doc.setLineWidth(state.lineWidth + 0.5);
	drawRect(doc, cityBorderX1, cityBorderX2, lastPosY, lastPosY + boxHeight);
	drawRect(doc, subdistrictBorderX1, subdistrictBorderX2, lastPosY, lastPosY + boxHeight);

	doc.setFontType('bold');
	doc.setFontSize(8);
	doc.text(data.city, cityTextPosX, textPosY, { align: 'center' });
	doc.text(data.subdistrict, subdistrictTextPosX, textPosY, { align: 'center' });
	doc.setFontSize(state.fontSize);
	doc.setFontType('normal');

	doc.setLineWidth(state.lineWidth);

	lastPosY += state.padding + boxHeight;

	doc.line(state.minX, lastPosY, state.maxX, lastPosY);

	if (data.isUnboxingInstructionsVisible) {
		lastPosY += state.padding;
		const unboxingTextPosY = lastPosY + state.padding;
		const unboxingTextPosX = state.minX + (state.maxX - state.minX) / 2;
		doc.setFontType('bold');
		doc.setFontSize(7);
		doc.setTextColor(255, 0, 0);
		doc.text('WAJIB VIDEO UNBOXING UNTUK KLAIM', unboxingTextPosX, unboxingTextPosY, {
			align: 'center',
		});
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(state.fontSize);
		doc.setFontType('normal');

		lastPosY = unboxingTextPosY + state.padding;

		doc.line(state.minX, lastPosY, state.maxX, lastPosY);
	}

	return lastPosY;
};

const weightLayout = (doc, state, data, orderIdBarcodeImage) => {
	let lastPosY = state.currentY + 2 * state.padding;

	const { minX, maxX, padding, lineHeight } = state;
	const colPosX1 = minX + padding;
	const widthEachCol = (maxX - padding - colPosX1) / 4;
	let colPosX2 = colPosX1 + widthEachCol - 5;
	let colPosX3 = colPosX2 + widthEachCol - 5;
	const colPosX4 = colPosX3 + widthEachCol;

	const barcodeWidth = 80;
	const barcodeHeight = 30;
	const drawText = (text, x, y, bold = false) => {
		if (bold) doc.setFontType('bold');
		doc.text(text, x, y);
		doc.setFontType('normal');
	};

	doc.addImage(
		orderIdBarcodeImage,
		'PNG',
		colPosX4 - 3,
		lastPosY - lineHeight - 1,
		barcodeWidth,
		barcodeHeight,
	);
	drawText(data.orderIdLabel, colPosX4, lastPosY - lineHeight + barcodeHeight, true);

	if (data.isWeightVisible) {
		const totalWeight = data.totalWeight;
		const isCeil = totalWeight % 1000 > 300;
		const weightKg = totalWeight / 1000;
		let totalWeightKg = isCeil ? Math.ceil(weightKg) : Math.floor(weightKg);
		if (totalWeightKg <= 0) totalWeightKg = 1;
		const weightLabel = `${totalWeightKg} Kg`;

		drawText('Berat:', colPosX1, lastPosY, true);
		drawText(weightLabel, colPosX1, lastPosY + lineHeight);
	} else {
		colPosX2 = colPosX1;
		colPosX3 = colPosX2 + widthEachCol;
	}

	if (data.isShowShipping) {
		drawText(data.courier, colPosX2, lastPosY, true);
		drawText(data.courierService, colPosX2, lastPosY + lineHeight);
	} else {
		colPosX3 = colPosX2;
	}

	if (!data.isCod && data.isShowShippingCost) {
		drawText('Ongkir:', colPosX3, lastPosY, true);
		drawText(data.shippingCostLabel, colPosX3, lastPosY + lineHeight);
	}

	lastPosY += barcodeHeight - lineHeight + padding;
	doc.line(minX, lastPosY, maxX, lastPosY);

	return lastPosY;
};

const productSection = (doc, state, data) => {
	let lastPosY = state.currentY + state.padding;

	const colPosX1 = state.minX + state.padding;
	const colPosX2 = colPosX1 + 140;
	const colPosX3 = state.maxX - state.padding;

	lastPosY += state.padding;

	doc.setFontType('bold');
	doc.text('Produk', colPosX1, lastPosY);
	doc.text('Variasi', colPosX2, lastPosY);
	doc.text('Jumlah', colPosX3, lastPosY, { align: 'right' });
	doc.setFontType('normal');

	lastPosY += state.padding;

	doc.line(state.minX, lastPosY, state.maxX, lastPosY);

	lastPosY += state.padding * 2;

	data.products.forEach((item) => {
		const namePosY = docTextRowHandler(
			doc,
			item.name,
			colPosX1,
			lastPosY,
			38,
			state.lineHeight,
		);

		const variantPosY = docTextRowHandler(
			doc,
			item.variant,
			colPosX2,
			lastPosY,
			26,
			state.lineHeight,
		);

		doc.text(`${item.quantity} pcs`, colPosX3, lastPosY, { align: 'right' });

		lastPosY = Math.max(namePosY, variantPosY) + state.lineHeight;
	});

	const btmLineThreshold = state.height - state.margin - 15;
	lastPosY = lastPosY > btmLineThreshold ? btmLineThreshold : lastPosY;

	doc.setFillColor(255, 255, 255);
	doc.rect(state.minX - state.margin, lastPosY, state.width, 15 + state.margin, 'F');
	doc.line(state.minX, lastPosY, state.maxX, lastPosY);

	lastPosY += state.padding * 2;

	const totalPricePosX = state.minX + (state.maxX - state.minX) / 4;
	const totalPcsPosX = state.minX + ((state.maxX - state.minX) * 3) / 4;

	doc.setFontType('bold');
	doc.setFontSize(8);
	if (data.isDisplayTotal) {
		doc.text(`Total: ${formatMoney(data.totalPrice, 'IDR', true)}`, totalPricePosX, lastPosY, {
			align: 'center',
		});
	}
	doc.text(`Total Produk: ${data.totalPcs} pcs`, totalPcsPosX, lastPosY, { align: 'center' });
	doc.setFontSize(state.fontSize);
	doc.setFontType('normal');

	lastPosY += state.padding;

	return lastPosY;
};

const getWeight = (params, packingSlip) => {
	const { order, isUsePcsInformation } = params;

	let totalWeight = 0;
	let totalPcsProduct = 0;

	if (order.type === 'form') {
		const customer = order.customer_data;
		const variations = customer.variations || [];
		const singleQty = customer.quantity || 1;

		if (variations.length > 0) {
			variations.forEach((variationItem) => {
				const variationWeight = variationItem.weight * variationItem.quantity;
				totalWeight += variationWeight;
				if (isUsePcsInformation) {
					const uomPcs = order.product_data?.uom?.value || 1;
					const uomPcsXQty = uomPcs * variationItem.quantity;
					totalPcsProduct += uomPcsXQty;
				}
			});
		} else {
			const singleProductWeight = order.product_weight * singleQty;
			totalWeight = singleProductWeight;

			if (isUsePcsInformation) {
				const uomPcs = order.product_data?.uom?.value || 1;
				const uomPcsXQty = uomPcs * singleQty;
				totalPcsProduct = uomPcsXQty;
			}
		}
	} else {
		const orderCartItems =
			packingSlip && packingSlip.items ? packingSlip.items : order.cart_items;
		orderCartItems.forEach((item) => {
			const cartItemWeight = item.weight * item.qty;
			totalWeight += cartItemWeight;
		});
	}

	return { totalWeight, totalPcsProduct };
};

const getProducts = (params, packingSlip) => {
	const { order, isUsePcsInformation, isUseProductSupplierName, selectedSubmissions, settings } = params;

	let totalPcsProduct = 0;
	let totalProducts = 0;
	const productsTable = [];
	const customer = order.customer_data;
	let productName = order.product_data?.name || order.product_name || '';
	let quantityValue = customer.quantity || 1;

	const isAddProductCode = settings && settings.includes('add_product_code');

	if (isAddProductCode) {
		productName = `${productName} - ${order?.product_data.code ?? ''}`;
	}

	if (isUseProductSupplierName) {
		const submission = selectedSubmissions.find((sub) => sub._id === order._id);
		productName = submission?.product_name || productName;
		if (isAddProductCode) {
			productName = `${productName} - ${submission?.product_code ?? ''}`;
		}
	}

	if (isUsePcsInformation) {
		const uomPcs = order.product_data?.uom?.value || 1;
		quantityValue *= uomPcs;
	}

	const variations = customer.variations || [];
	const variation = customer.variation || '';

	const addProductToTable = (name, variant, quantity) => {
		productsTable.push({ name, variant, quantity });
		totalProducts += quantity;
		if (isUsePcsInformation) {
			totalPcsProduct += quantity;
		}
	};

	if (order.type === 'form') {
		if (variations.length > 0) {
			variations.forEach((variationItem, index) => {
				let quantity = variationItem.quantity;
				if (isUsePcsInformation) {
					const uomValue = order.product_data?.variations?.prices[index]?.uom?.value || 1;
					quantity *= uomValue;
				}
				addProductToTable(productName, variationItem.value, quantity);
			});
		} else {
			addProductToTable(productName, variation, quantityValue);
		}
	} else {
		const orderCartItems = packingSlip ? packingSlip.items : order.cart_items;
		const submission = selectedSubmissions.find((sub) => sub._id === order._id);

		orderCartItems.forEach((item) => {
			const productSupplier = submission?.products?.find(
				(sub) => sub.product_id?.$oid === item.source_id,
			);
			const uom = getUomByVariation(productSupplier, item);
			const qty = uom && isUsePcsInformation ? uom.value : item.qty;
			const name = isUseProductSupplierName ? productSupplier.name : item.product_name;
			const variant = item.variation ? item.variation.replace(/\|\|/g, ' - ') : '';
			addProductToTable(name, variant, qty);
		});
	}

	return {
		products: productsTable,
		totalPcs: isUsePcsInformation ? totalPcsProduct : totalProducts,
		totalPrice: order.gross_revenue || order.total_price,
	};
};

export const shippingLayoutSix = (
	params,
	packingSlip,
	barcodeOptions,
	generateBarcode,
	insertInstructions,
) => {
	const {
		doc,
		order,
		store,
		pageFormat,
		courierLogos = [],
		instructions = [],
		isUnboxingInstructionsVisible,
		isWeightVisible,
		isShowShipping,
		isShowShippingCost,
		isCourierVisible,
		isSenderPhoneVisible,
		isLast,
		isDisplayTotal,
	} = params;

	const canvasState = {
		margin: 10,
		padding: 5,
		width: pageFormat[0],
		height: pageFormat[1],
		currentY: 0,
		fontSize: 7,
		lineWidth: 0.2,
		lineHeight: 8.5,
		get minX() {
			return this.margin;
		},
		get minY() {
			return this.margin;
		},
		get maxX() {
			return this.width - this.margin;
		},
		get maxY() {
			const maxValue = this.height - this.margin;
			return this.currentY > maxValue ? maxValue : this.currentY;
		},
	};

	const grossRevenue = order.gross_revenue || order.total_price;
	const orderTotal = formatMoney(grossRevenue, 'IDR', true);

	const paymentMethod =
		order.payment && order.payment.method && order.payment.method !== ''
			? order.payment.method
			: 'bank_transfer';
	const isCod = paymentMethod === 'cod';
	const shippingCost = order.shipping.cost;
	let shippingCostLabel = '';

	if (isShowShippingCost && shippingCost && shippingCost !== 0) {
		shippingCostLabel = `${formatMoney(shippingCost, 'IDR', true)}`;
	}

	// set document text color
	doc.setTextColor(0, 0, 0);
	doc.setLineWidth(canvasState.lineWidth);

	// set header section
	let shippingCourier = order.shipping.courier || '';
	if (shippingCourier === 'J&T') shippingCourier = 'jnt';
	const courierLogo = courierLogos.find(({ key }) => key === shippingCourier);
	// const codLabel = isCod ? (isShowShippingCost ? `COD: ${shippingCostLabel}` : 'COD') : 'NON-COD';
	const codLabel = isCod ? `COD: ${orderTotal}` : 'NON-COD';
	canvasState.currentY = headerLayout(doc, canvasState, courierLogo, codLabel, isCourierVisible);

	// order ID and awb section
	const receiptNumber =
		order.shipping.receipt_number && order.shipping.receipt_number !== ''
			? order.shipping.receipt_number
			: false;
	const awbBarcodeOptions = Object.assign({}, barcodeOptions, { width: 2 });
	const awbBarcodeImage = receiptNumber
		? generateBarcode(receiptNumber, awbBarcodeOptions)
		: false;
	const orderIdLabel = `#${order.order_id}`;
	const awbLabel = receiptNumber ? `Resi: ${receiptNumber}` : '-';
	canvasState.currentY = awbLayout(doc, canvasState, awbBarcodeImage, orderIdLabel, awbLabel);

	// address section
	const addressDetails = [];

	if (order.customer_data.subdistrict_name) {
		addressDetails.push(`Kec. ${order.customer_data.subdistrict_name}`);
	}
	if (order.customer_data.city_name) addressDetails.push(order.customer_data.city_name);
	if (order.customer_data.province_name) addressDetails.push(order.customer_data.province_name);
	if (order.customer_data.zip) addressDetails.push(order.customer_data.zip);

	const addressData = {
		receiverName: order.customer_data.name,
		senderName: store.name,
		receiverPhone: order.customer_data.phone,
		senderPhone: store.phone,
		address: order.customer_data.address,
		city: order.customer_data.city_name,
		subdistrict: order.customer_data.subdistrict_name,
		addressDetail: addressDetails.join(', '),
		notes: order.customer_data.notes,
		instructions,
		isUnboxingInstructionsVisible,
		isSenderPhoneVisible,
	};
	canvasState.currentY = addressLayout(doc, canvasState, addressData, insertInstructions);

	// weigth section
	const barcodeValue = order.order_id;
	const orderIdBarcodeOptions = Object.assign({}, barcodeOptions, { width: 2 });
	const orderIdBarcodeImage = generateBarcode(barcodeValue, orderIdBarcodeOptions);

	const courierService = getCourierServiceLabel(order?.shipping?.courier, order?.shipping?.service);

	const weightData = {
		isWeightVisible,
		isShowShipping,
		courier: order.shipping.courier ? order.shipping.courier.toUpperCase() : '',
		courierService,
		isCod,
		isShowShippingCost,
		shippingCostLabel,
		orderIdLabel: `Order ID: ${order.order_id}`,
		...getWeight(params, packingSlip),
	};
	canvasState.currentY = weightLayout(doc, canvasState, weightData, orderIdBarcodeImage);

	// product section
	const productData = getProducts(params, packingSlip);
	productData.isDisplayTotal = isDisplayTotal;
	canvasState.currentY = productSection(doc, canvasState, productData);

	// set canvas border
	doc.line(canvasState.minX, canvasState.minY, canvasState.maxX, canvasState.minY); // top border
	doc.line(canvasState.maxX, canvasState.minY, canvasState.maxX, canvasState.maxY); // right border
	doc.line(canvasState.minX, canvasState.maxY, canvasState.maxX, canvasState.maxY); // bottom border
	doc.line(canvasState.minX, canvasState.minY, canvasState.minX, canvasState.maxY); // left border

	if (!isLast) {
		doc.addPage(pageFormat);
	}

	return {
		baseX: canvasState.minX,
		baseY: canvasState.minY,
		prevBaseY: canvasState.currentY,
	};
};
